const en = {
  // Nav
  nav_home: "Home",
  nav_shop: "Shop",
  nav_categories: "Categories",
  nav_best_selling: "Best Selling",
  nav_contact: "Contact",
  nav_reviews: "Reviews",
  my_account: "My Account",
  login_signup: "Login / Sign Up",

  // Hero defaults
  hero_subtitle: "Exclusive Collection by",
  hero_tagline: "Elegance in Every Thread",
  hero_button: "Shop Now",

  // Categories
  home_categories_subtitle: "Curated For You",
  home_categories_title: "Shop by Category",

  // Best selling
  home_bestselling_subtitle: "Most Loved",
  home_bestselling_title: "Best Selling Products",

  // Shop
  home_shop_subtitle: "Browse All",
  home_shop_title: "Shop by Collection",

  // Product card
  out_of_stock: "OUT OF STOCK",
  added_to_cart: "Added to cart",

  // Product detail
  fatema_farista_collection: "Fatema Farista Collection",
  product_not_found: "Product not found",
  go_home: "Go Home",
  back: "Back",
  select_size: "Select Size",
  quantity: "Quantity",
  buy_now: "Buy Now",
  add_to_cart: "Add to Cart",
  please_select_size: "Please select a size",
  product_out_of_stock: "This product is out of stock",
  only_left: "Only {count} left in stock!",
  only_left_size: "Only {count} left in this size!",
  off: "OFF",
  you_may_also_like: "You May Also Like",
  similar_products: "Similar Products",
  related_products: "Related Products",
  recently_viewed: "Recently Viewed",
  please_login_wishlist: "Please login to add to wishlist",
  removed_from_wishlist: "Removed from wishlist",
  added_to_wishlist: "Added to wishlist",

  // Cart
  cart: "Cart",
  your_cart_empty: "Your cart is empty",
  continue_shopping: "Continue Shopping",
  total: "Total",
  checkout: "Checkout",
  size_label: "Size",

  // Checkout
  checkout_title: "Checkout",
  delivery_info: "Delivery Information",
  name_label: "Name",
  email_label: "Email (Optional)",
  phone_label: "Phone Number",
  address_label: "Delivery Address",
  your_name: "Your name",
  your_email: "your@email.com",
  phone_placeholder: "01XXXXXXXXX",
  address_placeholder: "Enter your full address",
  go_back: "Go Back",
  order_summary: "Order Summary",
  delivery_area: "Delivery Area",
  inside_dhaka: "Inside Dhaka",
  outside_dhaka: "Outside Dhaka",
  subtotal: "Subtotal",
  delivery: "Delivery",
  payment_method: "Payment Method",
  cash_on_delivery: "Cash on Delivery",
  coupon_code: "Coupon Code",
  enter_code: "Enter code",
  apply: "Apply",
  remove: "Remove",
  discount: "Discount",
  grand_total: "Grand Total",
  confirm_order: "Confirm Order",
  processing: "Processing...",
  required: "*",

  // Thank you
  thank_you: "Thank You!",
  order_confirmed: "Your order has been successfully confirmed.",
  order_number: "Order Number",
  we_will_contact: "We will contact you shortly. You can check your order status from the profile page.",
  representative_contact: "One of our customer representatives will contact you shortly to confirm your order.",
  need_help: "Need help? Reach out to us",
  call_us: "Call Us",
  whatsapp: "WhatsApp",
  message_us: "Message Us",
  view_orders: "View Orders",

  // Auth
  welcome_back: "Welcome Back",
  create_account: "Create Account",
  reset_password: "Reset Password",
  login_subtitle: "Log in to your account",
  signup_subtitle: "Create a new account",
  enter_email: "Enter your email",
  email: "Email",
  password: "Password",
  forgot_password: "Forgot password?",
  login: "Login",
  sign_up: "Sign Up",
  send_reset_link: "Send Reset Link",
  loading: "Loading...",
  or: "OR",
  continue_google: "Continue with Google",
  connecting: "Connecting...",
  no_account: "Don't have an account?",
  have_account: "Already have an account?",
  reset_link_sent: "A password reset link has been sent to your email.",

  // Profile
  back_to_shop: "Back to Shop",
  logout: "Logout",
  my_account_title: "My Account",
  profile: "Profile",
  orders: "Orders",
  full_name: "Full Name",
  phone: "Phone",
  address: "Address",
  save_profile: "Save Profile",
  saving: "Saving...",
  no_orders_yet: "You have no orders yet.",
  shop_now: "Shop Now",
  cancel: "Cancel",
  reorder: "Reorder",
  items: "items",
  tracking: "Tracking",
  courier_status: "Courier Status",

  // Wishlist
  my_wishlist: "My Wishlist",
  wishlist_empty: "Your wishlist is empty",
  browse_products: "Browse Products",

  // Order details
  back_to_profile: "Back to Profile",
  invoice: "Invoice",
  order_number_label: "Order Number",
  date: "Date",
  shipping_address: "Shipping Address",
  not_provided: "Not provided",
  items_label: "Items",
  no_items: "No items",
  qty: "Qty",
  cancel_order: "Cancel Order",
  total_amount: "Total Amount",

  // About
  our_story: "Our Story",
  our_vision: "Our Vision",
  our_vision_text: "We believe every child deserves the safest and most joyful start. At Lovira Kids, we carefully curate baby toys, feeding essentials, diapers, and care products that parents across Bangladesh can trust.",
  quality_promise: "Quality Promise",
  quality_promise_text: "Every product is carefully selected and quality-checked for your baby's safety. From soft organic cottons to BPA-free feeding gear, we source only premium, baby-friendly materials.",
  contact_us: "Contact Us",

  // Info pages
  order_procedure_title: "Order Procedure",
  order_procedure_content: `Ordering from our website is very simple. Follow the steps below:

1. Select your desired product and choose a size.
2. Click the "Add to Cart" button.
3. Go to your cart and review your order.
4. Click the "Checkout" button.
5. Enter your name, phone number, and delivery address.
6. Confirm your order.
7. We will contact you by phone to confirm the order.
8. Pay via Cash on Delivery when the product is delivered.`,

  return_policy_title: "Return, Refund & Exchange Policy",
  return_policy_content: `We value customer satisfaction above all. Here is our return and exchange policy:

Return Policy

• Return/exchange requests must be made within 3 days of receiving the product.
• Products must be unused, undamaged, and in their original packaging.
• Customized or made-to-order products are not eligible for returns.
• Return shipping costs must be borne by the customer.

Refund Policy

• If a product is damaged or defective upon delivery, a full refund will be provided.
• Refunds will be processed to the original payment method within 5-7 business days after approval.
• For Cash on Delivery orders, refunds will be sent via bKash/Nagad to the customer's provided number.
• Partial refunds may be issued if only part of the order is returned.
• Refund requests must be accompanied by photos or videos as proof of the issue.
• Shipping charges are non-refundable unless the return is due to our error.

Exchange Policy

• Products can be exchanged for a different size or color within 3 days of delivery.
• The product must be unused and in its original packaging.
• If the exchanged product has a price difference, the customer must pay the additional amount.
• Exchange shipping costs must be borne by the customer.
• Exchange processing takes 3-5 business days after receiving the returned product.`,

  terms_title: "Terms & Conditions",
  terms_content: `By using this website, you agree to the following terms and conditions:

1. All product prices are displayed in Bangladeshi Taka (৳).
2. Product colors may vary slightly depending on your monitor/screen.
3. Product prices will not be changed after order confirmation.
4. Delivery typically takes 1-3 days inside Dhaka and 3-5 days outside Dhaka.
5. We reserve the right to modify these terms and conditions at any time.
6. No content from this website may be copied or used without permission.
7. Orders placed with incorrect information may be cancelled.`,

  privacy_title: "Privacy Policy",
  privacy_content: `Your privacy is extremely important to us. This policy describes how we collect, use, and protect your information:

• We only collect information necessary for order processing (name, phone, address, email).
• Your personal information is not sold or shared with third parties.
• Payment information is processed securely.
• Cookies are used to improve your browsing experience.
• You can request deletion of your account and data at any time.
• This policy may be updated from time to time.`,

  // Footer
  footer_contact: "Contact",
  footer_quick_links: "Quick Links",
  footer_information: "Information",
  footer_follow_us: "Follow Us",
  footer_home: "Home",
  footer_shop: "Shop",
  footer_categories: "Categories",
  footer_contact_link: "Contact",
  footer_order_procedure: "Order Procedure",
  footer_return_policy: "Return, Refund & Exchange",
  footer_terms: "Terms & Conditions",
  footer_privacy: "Privacy Policy",

  // Search
  search_placeholder: "Search products...",
  category_label: "Category",
  all_categories: "All Categories",
  min_price: "Min Price",
  max_price: "Max Price",
  sort_by: "Sort By",
  relevance: "Relevance",
  price_low_high: "Price: Low → High",
  price_high_low: "Price: High → Low",
  clear_filters: "Clear Filters",
  searching: "Searching...",
  no_products_found: "No products found",
  products_found: "{count} products found",

  // All Products
  all_products: "All Products",
  view_all: "View All",
  new_arrivals: "New Arrivals",
  latest_collection: "Latest Collection",
  filter_category: "Category",
  filter_sort: "Sort",
  sort_newest: "Newest",
  sort_price_low: "Price: Low to High",
  sort_price_high: "Price: High to Low",

  // Order Tracking
  track_order: "Track Order",
  track_order_subtitle: "Enter your order number to check the status",
  order_number_input: "Order Number",
  order_number_placeholder: "e.g. ORD-XXXXXX",
  track_button: "Track",
  order_not_found: "Order not found. Please check your order number.",
  order_status: "Order Status",
  status_pending: "Pending",
  status_confirmed: "Confirmed",
  status_processing: "Processing",
  status_shipped: "Shipped",
  status_delivered: "Delivered",
  status_cancelled: "Cancelled",
  status_returned: "Returned",
  ordered_on: "Ordered on",

  // Promo
  not_found: "Page Not Found",
  not_found_desc: "Sorry, the page you're looking for doesn't exist.",
  return_home: "Return Home",
};

const bn: typeof en = en;

export const translations = { en, bn } as const;
export type TranslationKey = keyof typeof en;
